export default {
  state: {
    startDate: '',
    endDate: ''
  },
  mutations: {
    setStartDate (state, date) {
      state.startDate = date;
    }
  },
  actions: {

  }
};
